import React from 'react';
import CustomFieldsManager from '../../../../../components/CustomFieldsManager';
import { CustomField } from '../../../../../types';

interface CustomFieldsSectionProps {
  customFields: CustomField[];
  onChange: (fields: CustomField[]) => void;
}

const CustomFieldsSection: React.FC<CustomFieldsSectionProps> = ({ customFields, onChange }) => {
  return (
    <div className="pt-4 mt-4 border-t border-tinta/10">
      <CustomFieldsManager fields={customFields} onChange={onChange} />
    </div>
  );
};

export default CustomFieldsSection;
